module.exports = __webpack_public_path__ + "img/todos_pueden_volar.4402ced8.jpg";